import { useApplication } from 'global/Application/Context';
import PageLoading from 'global/PageLoading';
import React, { useEffect, useState } from 'react';

const ActionItem: React.FC = () => {

    const [documentFile, setDocumentFile] = useState<string | null>(null);

    const application = useApplication();

    useEffect(() => {
        (async () => {
            const dataSource = application.dataSource;
            const bcbs_config_actionitems = await dataSource.bcbs_config_actionitems_getAsync();

            if (bcbs_config_actionitems) {
                const blob = new Blob([JSON.stringify(bcbs_config_actionitems)], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                setDocumentFile(url);
            }
        })();
    }, []);

    if (documentFile)
        return (
            <iframe
                style={{
                    width: '100%',
                    height: window.innerHeight - 100,
                    border: 'none',
                    // position: 'fixed'
                }}
                src={`./diagnosis/bcbs_config_actionitem.html?file=${encodeURIComponent(documentFile)}`}
            />
        );

    return (
        <PageLoading />
    )
};

export default ActionItem;